import { JSX } from 'react';

import ArticleCard from 'components/BaseHelpers/ArticleCard';
import ArticleGrid from 'components/BaseHelpers/ArticleGrid';
import articleGridStyles from 'components/BaseHelpers/ArticleGrid/ArticleGrid.module.scss';
import LinksGridSection from 'components/BaseHelpers/LinksGridSection/LinksGridSection';
import LocationCard from 'components/BaseHelpers/LocationCard/LocationCard';
import PeopleGrid from 'components/BaseHelpers/PeopleGrid';

import { SiteSearchResultItem } from '../../useSiteSearch';

export type ResultsListingProps = {
  items: SiteSearchResultItem[];
  resultsToShow: number;
};

const ResultsListing = (props: ResultsListingProps): JSX.Element => {
  const { items, resultsToShow } = props;
  const itemsForCurrentPage = items.slice(0, resultsToShow);

  if (itemsForCurrentPage.length === 0) {
    return <></>;
  }

  const type = itemsForCurrentPage[0].postType;

  if (type === 'people') {
    type PeopleItem = Extract<SiteSearchResultItem, { postType: 'people' }>;
    return <PeopleGrid items={itemsForCurrentPage as PeopleItem[]} />;
  }

  if (type === 'services') {
    type ServiceItem = Extract<SiteSearchResultItem, { postType: 'services' }>;

    return (
      <LinksGridSection
        heading=""
        description=""
        displayCount={0}
        showAll={true}
        showAllLabel=""
        links={itemsForCurrentPage as ServiceItem[]}
      />
    );
  }

  if (type === 'newsinsights') {
    type ArticleItem = Extract<SiteSearchResultItem, { postType: 'newsinsights' }>;
    return <ArticleGrid items={itemsForCurrentPage as ArticleItem[]} />;
  }

  if (type === 'resources' || type === 'office') {
    return (
      <ul className={articleGridStyles.list}>
        {itemsForCurrentPage.map((item) => {
          if (item.postType === 'office') {
            return (
              <li className={articleGridStyles['list-item']} key={`${JSON.stringify(item)}`}>
                <LocationCard {...item} className={articleGridStyles['card']} />
              </li>
            );
          }

          if (item.postType === 'resources') {
            return (
              <li className={articleGridStyles['list-item']} key={`${JSON.stringify(item)}`}>
                <ArticleCard {...item} className={articleGridStyles['card']} />
              </li>
            );
          }
          return null;
        })}
      </ul>
    );
  }

  const never: never = type;
  return never;
};

export default ResultsListing;
